<template>
	<div class="userinfo">
		<div ref="height_top">
			<el-row>
				<el-col :span="24">
					<div v-bind:style="{ height: tableHeight + 'px' }" v-loading="loading">
					<div v-if="!loading && (!tableData || tableData.length === 0)" class="empty-data-box"
						:style="{ height: tableHeight - 10 + 'px' }">
						<el-empty description="暂无数据" :image-size="120">
							<template #description>
								<div class="empty-subtitle">暂无校对记录</div>
							</template>
						</el-empty>
					</div>
					<div v-for="(item,key) in tableData">
						<el-descriptions title="ERP数据" :column="4">
							<el-descriptions-item label="推送时间">{{item.create_time}}</el-descriptions-item>
							<el-descriptions-item label="行数">{{item.total_row}}</el-descriptions-item>
							<el-descriptions-item label="推送数量">{{item.total_num}}</el-descriptions-item>
							<el-descriptions-item label="推送金额">{{item.total_money}}</el-descriptions-item>
							<el-descriptions-item label="操作">
								<el-button type="success" @click="checkstorage(item.id)" v-if="item.state===0">校对</el-button>
								<el-button type="warning" @click="particulars(item.id)" :disabled="item.state!=1">详情</el-button>
								<el-button type="danger" @click="del(item.id)">删除</el-button> 
							</el-descriptions-item>
						</el-descriptions>
						<el-divider />
					</div>
						
						
					</div>
				</el-col>
				<el-col :span="24" class="page" style="display: flex; justify-content: flex-end;">
					<el-pagination :pager-count="5" size="small" class="pagination" :current-page="page" background :page-size="parseInt(page_size)" layout="prev, pager, next" @current-change="handleCurrentChange" :total="total">
					</el-pagination>
				</el-col>
			</el-row>
		</div>
		<el-dialog v-model="dialogTableVisible" title="手动校对数据" width="95%" :close-on-click-modal='false' :close-on-press-escape='false'>
			<el-row>
				<el-col :span="24">
					<el-select v-model="particulars_form.difference" @change="change_particulars_search" placeholder="选择是否有差异数据" style="width: 240px">
						<el-option v-for="item in differenceList" :key="item.id" :label="item.name" :value="item.id" />
					</el-select>
				</el-col>
				<el-col :span="24">
					<el-table :data="particulars_tableData" :height="tableHeight" v-loading="particulars_loading" :header-cell-style="{'background-color': '#e5e5e5'}" size="small" style="width: 100%">
						<el-table-column label="原数据" header-align="center">
						<el-table-column prop="original_brand_name" label="品牌" width="80" show-overflow-tooltip />
						<el-table-column prop="original_name" label="品名" width="" show-overflow-tooltip />
						<el-table-column prop="original_model" label="型号" width="" show-overflow-tooltip />
						<el-table-column prop="original_order_no" label="订货号" width="" show-overflow-tooltip />
						<el-table-column prop="original_price" label="列表价" align="right" header-align="left" show-overflow-tooltip />
						<el-table-column prop="original_discount" label="折扣" align="right" header-align="left" show-overflow-tooltip />
						<el-table-column prop="original_real_price" label="单价" align="right" header-align="left" show-overflow-tooltip />
						<el-table-column prop="original_num" label="数量" align="right" header-align="left" show-overflow-tooltip />
						<el-table-column prop="original_real_money" label="金额" align="right" header-align="left" show-overflow-tooltip />
						<el-table-column prop="" label="操作" show-overflow-tooltip >
							<template #default="scope">
								<el-button type="danger" size="small" v-if="!scope.row.present_id" @click="undercarriage(scope.row.original_id)">删除</el-button>
							</template>
							
						</el-table-column>
					</el-table-column>
						<el-table-column label="新数据" header-align="center">
							<el-table-column prop="present_brand_name" label="品牌" width="80" show-overflow-tooltip />
							<el-table-column prop="present_name" label="品名" width="" show-overflow-tooltip />
							<el-table-column prop="present_model" label="型号" width="" show-overflow-tooltip />
							<el-table-column prop="present_order_no" label="订货号" width="" show-overflow-tooltip />
							<el-table-column prop="present_price" label="列表价" align="right" header-align="left" show-overflow-tooltip />
							<el-table-column prop="present_discount" label="折扣" align="right" header-align="left" show-overflow-tooltip />
							<el-table-column prop="present_real_price" label="单价" align="right" header-align="left" show-overflow-tooltip />
							<el-table-column prop="present_num" label="数量" align="right" header-align="left" show-overflow-tooltip />
							<el-table-column prop="present_real_money" label="金额" align="right" header-align="left" show-overflow-tooltip />
							<el-table-column prop="" label="操作" show-overflow-tooltip >
								 <template #default="scope">
										<el-button type="success" size="small" v-if="scope.row.present_id && particulars_form.difference==2" @click="substitute(scope.row.original_id,scope.row.present_id)">替换</el-button>
								</template>
							</el-table-column>
						</el-table-column>
					</el-table>
				</el-col>
				<el-col :span="24" class="page" style="display: flex; justify-content: flex-end;">
					<el-pagination :pager-count="5" size="small" class="pagination" :current-page="particulars_page" background :page-size="particulars_page_size" layout="prev, pager, next" @current-change="particulars_handleCurrentChange" :total="particulars_total">
					</el-pagination>
				</el-col>
			</el-row>
		</el-dialog>
	</div>
</template>
<script>
import { ElMessage, ElMessageBox } from 'element-plus'
export default {
	components: {},
	data() {

		return {
			differenceList: [{ id: 1, name: '无差异' }, { id: 2, name: '有差异' }],
			particulars_total: 0,
			particulars_page: 1,
			particulars_page_size: 120,
			particulars_tableData: [],
			tableData: [],
			tableHeight: 0,
			total: 0,
			page: 1,
			page_size: 120,
			dialogTableVisible: false,
			particulars_loading: false,
			loading: false,
			particulars_form: {difference:2},
			form: {},
			particulars_id: '',

		}
	},
	props: [],

	updated() {

	},


	mounted() {

	},

	activated() {

	},
	created() {
		this.search()
		this.tableHeight_fun()
	},
	watch: {

	},
	methods: {
		substitute(original_id,present_id){
			ElMessageBox.confirm(
					'确认替换数据！',
					'提示', {
						confirmButtonText: '确认',
						cancelButtonText: '取消',
						type: 'warning',
					}
				)
				.then(() => {
					this.substitute_ajax(original_id,present_id)
				})
				.catch(() => {

				})
		},
		async substitute_ajax(original_id,present_id) {
			this.particulars_loading = true
			await this.$axios.post('/api/yunsys.storage/replacestorage', { original_id,present_id }).then(async (res) => {
					var res = res.data;
					this.loading = false
					if (res.code !== 0) {
						return ElMessage({
							message: res.msg,
							type: 'error',
							grouping: true // 开启合并功能
						})
					}
					this.particulars_page = 1;
					this.particulars_search()
					this.$emit('pcsummary', {});
					return ElMessage({
						message: res.msg,
						type: 'success',
						grouping: true // 开启合并功能
					})

				})
				.catch(err => {
					this.loading = false
					return ElMessage({
						message: '系统错误',
						type: 'error',
						grouping: true // 开启合并功能

					})
				})
		},
		undercarriage(id){
			ElMessageBox.confirm(
					'确认删除此产品！',
					'提示', {
						confirmButtonText: '确认',
						cancelButtonText: '取消',
						type: 'warning',
					}
				)
				.then(() => {
					this.undercarriage_ajax(id)
				})
				.catch(() => {

				})
		},
		async undercarriage_ajax(id) {
			this.particulars_loading = true
			await this.$axios.post('/api/yunsys.storage/removestorage', { id }).then(async (res) => {
					var res = res.data;
					this.loading = false
					if (res.code !== 0) {
						return ElMessage({
							message: res.msg,
							type: 'error',
							grouping: true // 开启合并功能
						})
					}
					this.particulars_page = 1;
					this.$emit('pcsummary', {});
					this.particulars_search()
					return ElMessage({
						message: res.msg,
						type: 'success',
						grouping: true // 开启合并功能
					})

				})
				.catch(err => {
					this.loading = false
					return ElMessage({
						message: '系统错误',
						type: 'error',
						grouping: true // 开启合并功能

					})
				})
		},
		particulars(id) {
			this.dialogTableVisible = true;
			this.particulars_id = id;
			this.$nextTick(() => {
				this.particulars_search()
			})
		},
		del(id) {
			ElMessageBox.confirm(
					'确认删除此数据，不可恢复！',
					'提示', {
						confirmButtonText: '确认',
						cancelButtonText: '取消',
						type: 'warning',
					}
				)
				.then(() => {
					this.del_ajax(id)
				})
				.catch(() => {

				})
		},
		async del_ajax(id) {
			this.loading = true
			await this.$axios.post('/api/yunsys.storage/delcheckstorage', { id }).then(async (res) => {
					var res = res.data;
					this.loading = false
					if (res.code !== 0) {
						return ElMessage({
							message: res.msg,
							type: 'error',
							grouping: true // 开启合并功能
						})
					}
					this.page = 1;
					this.search()
					return ElMessage({
						message: res.msg,
						type: 'success',
						grouping: true // 开启合并功能
					})

				})
				.catch(err => {
					this.loading = false
					return ElMessage({
						message: '系统错误',
						type: 'error',
						grouping: true // 开启合并功能

					})
				})
		},
		checkstorage(id) {
			ElMessageBox.confirm(
					'确认校对数据！',
					'提示', {
						confirmButtonText: '确认',
						cancelButtonText: '取消',
						type: 'warning',
					}
				)
				.then(() => {
					this.checkstorage_ajax(id)
				})
				.catch(() => {

				})
		},
		async checkstorage_ajax(id) {
			this.loading = true
			await this.$axios.post('/api/yunsys.storage/checkstorage', { id }).then(async (res) => {
					var res = res.data;
					this.loading = false
					if (res.code !== 0) {
						return ElMessage({
							message: res.msg,
							type: 'error',
							grouping: true // 开启合并功能
						})
					}
					this.page = 1;
					this.search()
					return ElMessage({
						message: res.msg,
						type: 'success',
						grouping: true // 开启合并功能
					})

				})
				.catch(err => {
					this.loading = false
					return ElMessage({
						message: '系统错误',
						type: 'error',
						grouping: true // 开启合并功能

					})
				})
		},
		change_particulars_search(){
			this.particulars_tableData=[]
			this.particulars_page =1;
			this.particulars_search();
		},
		particulars_handleCurrentChange(val) {
			this.particulars_page = val;
			this.particulars_search();
		},
		async particulars_search() {
			this.particulars_loading = true
			var search = this.particulars_form;
			search.page = this.particulars_page;
			search.ps = this.particulars_page_size;
			search.id = this.particulars_id;
			await this.$axios.post('/api/yunsys.storage/differstorage', search).then(async (res) => {
					var res = res.data;
					this.particulars_loading = false
					if (res.code !== 0) {
						return ElMessage({
							message: res.msg,
							type: 'error',
							grouping: true // 开启合并功能
						})
					}
					var obj = this;
					this.particulars_total = res.data.total;
					var key = 0;
					res.data.data.forEach(item => {
						key = key + 1
						item.original_price = obj.$bn.multiply(item.original_price, 1, 2);
						item.original_real_price = obj.$bn.multiply(item.original_real_price, 1, 2);
						item.original_real_money = obj.$bn.multiply(item.original_real_money, 1, 2);
						item.original_discount = obj.$bn.multiply(item.original_discount, 1, 3);

						item.present_price = obj.$bn.multiply(item.present_price, 1, 2);
						item.present_real_price = obj.$bn.multiply(item.present_real_price, 1, 2);
						item.present_real_money = obj.$bn.multiply(item.present_real_money, 1, 2);
						item.present_discount = obj.$bn.multiply(item.present_discount, 1, 3);
					})
					this.particulars_tableData = res.data.data;

				})
				.catch(err => {
					this.particulars_loading = false
					return ElMessage({
						message: '系统错误',
						type: 'error',
						grouping: true // 开启合并功能

					})
				})
		},
		handleCurrentChange(val) {
			this.page = val;
			this.search();
		},
		async search() {
			this.$emit('pcsummary', {});
			this.loading = true
			var search = this.form;
			search.page = this.page;
			search.ps = this.page_size;
			await this.$axios.post('/api/yunsys.storage/getcheckstorage', search).then(async (res) => {
					var res = res.data;
					this.loading = false
					if (res.code !== 0) {
						return ElMessage({
							message: res.msg,
							type: 'error',
							grouping: true // 开启合并功能
						})
					}
					var obj = this;
					this.total = res.data.total;
					var key = 0;
					res.data.data.forEach(item => {
						key = key + 1
						    
						
					})
					this.tableData = res.data.data;

				})
				.catch(err => {
					this.loading = false
					return ElMessage({
						message: '系统错误',
						type: 'error',
						grouping: true // 开启合并功能

					})
				})
		},
		tableHeight_fun() {
			this.$nextTick(() => {
				this.tableHeight = window.innerHeight - this.$refs.height_top.getBoundingClientRect().top - 100
				console.log(this.tableHeight, 12122)
			})
		},
	}
}
</script>
<style lang="less" scoped>
</style>